export enum LockDownReasonEnum {
  Session = 'Session',
  Token = 'Token',
}
